import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_richtext_form = _resolveComponent("richtext-form");
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_el_table = _resolveComponent("el-table");
    return (_openBlock(), _createBlock(_component_el_table, {
        data: (_a = _ctx.competencyUnit.statements) === null || _a === void 0 ? void 0 : _a.filter((item) => item.answerTypeId === _ctx.answerTypeId),
        "scrollbar-always-on": true,
        "default-expand-all": ""
    }, {
        default: _withCtx(() => {
            var _a;
            return [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(((_a = _ctx.competencyUnit.customAnswerFields) === null || _a === void 0 ? void 0 : _a.filter((item) => item.answerType.id === _ctx.answerTypeId)) || [], (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (item.answerField.type === 'richtext')
                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 0,
                                label: item.label
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_richtext_form, {
                                        modelValue: item.description,
                                        "onUpdate:modelValue": ($event) => ((item.description) = $event),
                                        preview: ""
                                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]))
                            : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */));
                }), 128 /* KEYED_FRAGMENT */))
            ];
        }),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["data"]));
}
